import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { RenderStep } from '../components/FormControlRendering';
import { WidgetFormProps } from '../WidgetForm';
import { getResourceString } from '../../kentico/resource-strings';

const IncomeRelationWidgetForm: React.FC<WidgetFormProps> = (state) => {
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    const initialVals = {};
    state.formDefinition.form.field.map((field) => {
      initialVals[field['@column']] = field.properties.defaultvalue;
    })

    setInitialValues(initialVals);
  }, []);

  const handleSubmit = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    if (state.formData.BedrijfsNaam.value === initialValues.BedrijfsNaam
      && state.formData.BedrijfHuisnummer.value === initialValues.BedrijfHuisnummer
      && state.formData.BedrijfWoonplaats.value === initialValues.BedrijfWoonplaats
      && state.formData.BedrijfPostcode.value === initialValues.BedrijfPostcode
    ) {
      return;
    }

    state.handleSubmit(event);
  };
  
  return (
    <div className='col-12 mijn-fnv__edit-page p-0' ref={state.formFieldsRef}>
      <>
        {!state.formLoading && (
          <>
            <RenderStep
              formDefinition={state.formDefinition}
              fields={state.fields}
              visibleFields={state.visibleFields} 
              currentStepIndex={state.currentStepIndex} 
              formData={state.formData} 
              setFormData={state.setFormData}
              formErrors={state.formErrors} 
              handleChange={state.handleChange} 
              handleBlur={state.handleBlur}
              formSummaryData={null}
              navigateToStep={state.setHandleFormStepSpecific}
            />

            <button type="submit" className="btn btn-success btn-form-submit mt-4" onClick={handleSubmit}>{getResourceString("Form.Send.ButtonCaption")}</button>
          </>
        )}
      </>
    </div>
  );
};

export default IncomeRelationWidgetForm;